const UPDATE = 'modules/managePrivacyCheckboxStatus/UPDATE';

const reducer = (state = false, action) => {
  switch (action.type) {
    case UPDATE:
      return action.checked;
    default:
      return state;
  }
};

const updatePrivacyCheckboxStatus = checked => {
  return {
    checked,
    type: UPDATE,
  };
};

export { reducer as default, updatePrivacyCheckboxStatus };
